// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "center[data-v-394e646b]{margin:15vw}h1[data-v-394e646b]{color:var(--border);font-size:2em}", ""]);
// Exports
module.exports = exports;
